import { normalizeWorkspaceSubstage, SUBSTAGE_CONCLUIDO_COM_PROPOSTA } from './recuperacaoWorkspace';

export const PROPOSTA_ENVIADA_SUBSTAGE = SUBSTAGE_CONCLUIDO_COM_PROPOSTA;

export const ENVIO_PROPOSTA_NAO_MOTIVOS = [
  { key: 'aguarda-cliente', label: 'A aguardar decisão do cliente' },
  { key: 'fidelizado', label: 'Fidelizado' },
  { key: 'nao-avancou', label: 'Cliente decidiu não avançar' },
  { key: 'outro', label: 'Outro' },
] as const;

export function isEnvioPropostaSubstage(substage: string): boolean {
  const normalized = normalizeWorkspaceSubstage(substage);
  return normalized === PROPOSTA_ENVIADA_SUBSTAGE;
}
